import { Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from "recharts"

import { diagramColors, IAnalyticsPageDisplayUnit } from "@/types/IAnalytics"


export interface AnalyticsBarChartProps {
  data: any[] | undefined
  dataKeys: IAnalyticsPageDisplayUnit[]
  colors?: string[]
  tooltipContent?: any
}

export const AnalyticsBarChart = (props: AnalyticsBarChartProps) => {
  const { data, dataKeys, colors, tooltipContent } = props

  return (
    <BarChart width={1400} height={600} data={data}>
      <XAxis dataKey="period"/>
      <YAxis/>
      <Tooltip content={tooltipContent} />
      <Legend/>
      <CartesianGrid stroke="#f5f5f5"/>
      {
        dataKeys.map((data, index) => (
          <Bar
            key={index}
            minPointSize={1}
            dataKey={data.value}
            name={data.bigLabel}
            fill={(colors ?? diagramColors)[index]}
            label={{ fill: "white" }}/>
        ))
      }
    </BarChart>
  )
}
